import PromptPage from "./PromptPage";

export default PromptPage;  